<script setup lang="ts">
import type { AccordionItem } from '#ui/types';
import type { PropType } from 'vue';

import type { AssetSpecsSection } from '~/types/asset.type';

// PROPS
const { title, specs } = defineProps({
    title: { type: String as PropType<TypedTranslateReturn>, required: true },
    defaultOpen: { type: Boolean, default: false },
    groupedByAsset: { type: Boolean, default: false },
    grid: { type: Boolean, default: false },
    specs: { type: Array as PropType<AssetSpecsSection>, required: true },
});

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const isNotEmpty = computed<boolean>(() => specs.some(group => group.some(spec => spec[1] !== null)));
const accordionItems = computed<AccordionItem[]>(() => [{ label: title }]);
</script>

<template>
    <BaseAccordion v-if="isNotEmpty" size="xl" :items="accordionItems" :default-open="defaultOpen">
        <template #content>
            <div class="mb-3 flex flex-col gap-6" :class="grid && 'md:grid md:grid-cols-2'">
                <template v-for="(group, i) in specs" :key="i">
                    <div v-if="group.some(spec => spec[1] !== null)" class="flex flex-col gap-0">
                        <h3 v-if="groupedByAsset" class="text-highlighted text-base leading-6 font-medium">
                            {{ tt('asset.vehicleIndex', { index: i + 1 }) }}
                        </h3>
                        <SdpSpecItem v-for="(spec, j) in group" :key="j" :name="tt(spec[0])" :value="spec[1]" :color="spec[2]" />
                    </div>
                </template>
            </div>
        </template>
    </BaseAccordion>
</template>
